import { gql } from '@apollo/client';
import { PROGRAMME } from './programme';
import { SERVICE_PROVIDER } from './serviceProvider';
import { USER } from './user';

export const FUNDER = gql`
  fragment funder on Funder {
    createdAt
    id
    updatedAt
    contactPerson
    contactPersonContactNumber
    contactPersonEmail
    description
    leaderContactNumber
    leaderEmail
    leaderTitle
    name
    status
    organisationLeader
    physicalAddress
    website
    organisationUsersAddOns {
      id
      name
    }
    organisationUsersPlan {
      id
      name
    }
    programmes {
      ...programme
    }
    serviceProviders {
      ...serviceProvider
    }
    users {
      ...user
    }
  }
  ${SERVICE_PROVIDER}
  ${PROGRAMME}
  ${USER}
`;
